var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-info"},[_c('span',{class:{ capitalize: _vm.capitalize, uppercase: _vm.uppercase }},[_vm._v(_vm._s(_vm.text ? _vm.text : _vm.defaultText))]),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }